import { useState, useEffect, useCallback } from 'react';
import { API } from '../../App';

export function useWorkspace() {
  const [workspaces, setWorkspaces] = useState([]);
  const [activeWsId, setActiveWsId] = useState(() => localStorage.getItem('enterprise_ws_id') || '');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    API.get('/api/workspaces').then(res => {
      const list = res.data.workspaces || [];
      setWorkspaces(list);
      if (!activeWsId && list.length > 0) {
        setActiveWsId(list[0].id);
        localStorage.setItem('enterprise_ws_id', list[0].id);
      }
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const selectWorkspace = useCallback((id) => {
    setActiveWsId(id);
    localStorage.setItem('enterprise_ws_id', id);
  }, []);

  return { workspaces, activeWsId, selectWorkspace, loading };
}

export function WorkspaceSelector({ workspaces, activeWsId, onSelect }) {
  if (workspaces.length <= 1) return null;
  return (
    <select
      value={activeWsId}
      onChange={e => onSelect(e.target.value)}
      className="bg-[#0F0F0F] border border-[#2A2A2A] text-sm px-3 py-2 text-[#F5F5F5] focus:outline-none focus:border-[#FF4D00] min-w-[200px]"
    >
      {workspaces.map(ws => (
        <option key={ws.id} value={ws.id}>{ws.name}</option>
      ))}
    </select>
  );
}
